export const EVENT_KEY_ARROW_DOWN = 'ArrowDown'

export const EVENT_KEY_ARROW_LEFT = 'ArrowLeft'

export const EVENT_KEY_ARROW_RIGHT = 'ArrowRight'

export const EVENT_KEY_ARROW_UP = 'ArrowUp'

export const EVENT_KEY_ENTER = 'Enter'

export const EVENT_KEY_ESCAPE = 'Escape'

export const EVENT_KEY_SPACE_BAR = ' '

export const EVENT_NAME_ABORT = 'abort'

export const EVENT_NAME_BEFORE_UNLOAD = 'beforeunload'

export const EVENT_NAME_BLUR = 'blur'

export const EVENT_NAME_CHANGE = 'change'

export const EVENT_NAME_CLICK = 'click'

export const EVENT_NAME_COPY = 'copy'

export const EVENT_NAME_DRAG_END = 'dragend'

export const EVENT_NAME_DRAG_ENTER = 'dragenter'

export const EVENT_NAME_DRAG_LEAVE = 'dragleave'

export const EVENT_NAME_DRAG_OVER = 'dragover'

export const EVENT_NAME_DRAG_START = 'dragstart'

export const EVENT_NAME_DROP = 'drop'

export const EVENT_NAME_FOCUS = 'focus'

export const EVENT_NAME_INPUT = 'input'

export const EVENT_NAME_KEY_DOWN = 'keydown'

export const EVENT_NAME_MOUSE_MOVE = 'mousemove'

export const EVENT_NAME_MOUSE_UP = 'mouseup'

export const EVENT_NAME_MOUSE_DOWN = 'mousedown'

export const EVENT_NAME_MOUSE_ENTER = 'mouseenter'

export const EVENT_NAME_MOUSE_LEAVE = 'mouseleave'

export const EVENT_NAME_ONLINE = 'online'

export const EVENT_NAME_PAGE_HIDE = 'pagehide'

export const EVENT_NAME_PAGE_SHOW = 'pageshow'

export const EVENT_NAME_POINTER_MOVE = 'pointermove'

export const EVENT_NAME_POINTER_UP = 'pointerup'

export const EVENT_NAME_POINTER_CANCEL = 'pointercancel'

export const EVENT_NAME_RESIZE = 'resize'

export const EVENT_NAME_SCROLL = 'scroll'

export const EVENT_NAME_SELECT_START = 'selectstart'

export const EVENT_NAME_WHEEL = 'wheel'

export const EVENT_NAME_TOUCH_END = 'touchend'

export const EVENT_NAME_TOUCH_MOVE = 'touchmove'

export const EVENT_NAME_VISIBILITY_CHANGE = 'visibilitychange'

export const EVENT_NAME_ORIENTATION_CHANGE = 'orientationchange'

// our own event
export const EVENT_WYSIWYG_FOCUS = 'wysiwigfocus'
